export default {
  init: (Swiper) => {
    /* ---------------------------- Slider top home ---------------------------- */
    new Swiper('.swiper-slider-home .swiper-container', {
      spaceBetween: 20,
      slidesPerView: 1,
      speed: 900,
      autoplay: {
        delay: 5000
      },
      autoplayDisableOnInteraction: false,
      effect: 'fade',
      loop: true,
      navigation: {
        nextEl: '.swiper-next',
        prevEl: '.swiper-prev'
      },
      on: {
        slideNextTransitionStart: function () {
          if (jQuery('.swiper-slide-active').hasClass('switch_blanc')) { // couleur blanc
            jQuery('.switch-txt').removeClass('c_noir');
            jQuery('.switch-txt').addClass('c_blanc');
          } else { // couleur noir
            jQuery('.switch-txt').removeClass('c_blanc');
            jQuery('.switch-txt').addClass('c_noir');
          }
        }
      }
    });

    /* ---------------------------- Slider top home ---------------------------- */
    new Swiper('.swiper-slider-single .swiper-container', {
      spaceBetween: 20,
      slidesPerView: 1,
      speed: 900,
      autoplay: 2500,
      autoplayDisableOnInteraction: false,
      effect: 'fade',
      loop: true,
      navigation: {
        nextEl: '.swiper-next',
        prevEl: '.swiper-prev'
      }
    });

    /* ---------------------------- Slider actus home ---------------------------- */
    new Swiper('.slider-list-post .swiper-container', {
      spaceBetween: 20,
      slidesPerView: 4,
      speed: 900,
      loop: true,
      navigation: {
        nextEl: '.swiper-next',
        prevEl: '.swiper-prev'
      },
      autoplayDisableOnInteraction: true,
      breakpoints: {
        992: {
          slidesPerView: 2,
          spaceBetween: 20
        },
        768: {
          slidesPerView: 2,
          spaceBetween: 10
        },
        480: {
          slidesPerView: 1,
          spaceBetween: 10
        }
      }
    });

    /* ---------------------------- Slider actus single bottom ---------------------------- */
    new Swiper('.slider-actu-bottom .swiper-container', {
      spaceBetween: 20,
      slidesPerView: 4,
      speed: 900,
      loop: true,
      navigation: {
        nextEl: '.swiper-next',
        prevEl: '.swiper-prev'
      },
      autoplayDisableOnInteraction: true,
      breakpoints: {
        992: {
          slidesPerView: 3,
          spaceBetween: 20
        },
        768: {
          slidesPerView: 2,
          spaceBetween: 10
        },
        480: {
          slidesPerView: 1,
          spaceBetween: 10
        }
      }
    });

    /* ---------------------------- Slider innovation ---------------------------- */
    new Swiper('.swiper-slider-innovation .swiper-container', {
      spaceBetween: 20,
      slidesPerView: 1,
      speed: 900,
      autoplay: 1000,
      autoplayDisableOnInteraction: false,
      effect: 'fade',
      loop: true,
      navigation: {
        nextEl: '.swiper-next',
        prevEl: '.swiper-prev'
      }
    });

    /* ---------------------------- Navigation ---------------------------- */
    let body, menu;
    var init = function init() {
      body = document.querySelector('body');
      menu = document.querySelector('.menu-icon');
      applyListeners();
    };
    var applyListeners = function applyListeners() {
      menu.addEventListener('click', function () {
        return body.classList.toggle('nav-active');
      });
    };
    init();

    $('body').on('click', '.side-button-search', function (e) {
      e.preventDefault();
      $('body').addClass('search-active');
    });
    $('body').on('click', '.form-close', function (e) {
      e.preventDefault();
      $('body').removeClass('search-active');
      $('body').removeClass('newsletter-active');
    });

    // newsletter
    $('body').on('click', '.side-button-newsletter', function (e) {
      e.preventDefault();
      openNewsletterForm();
    });

    var newsHash = window.location.hash;
    if (newsHash === '#newsletter') {
      openNewsletterForm();
    }

    function openNewsletterForm() {
      $('body').addClass('newsletter-active');

      window.location.hash = 'newsletter';
    }

    /* ---------------------------- Fiche chantier single ---------------------------- */
    jQuery(document).on('click', '.fiche_chantier_off', function () {
      $('.fiche_chantier_on').show(200);
    });
    jQuery(document).on('click', '.fiche_chantier_on span', function () {
      $('.fiche_chantier_on').hide(200);
    });
    jQuery(document).on('click', '.switch-desc', function () {
      $('.content-rea').toggleClass('active');
    });

    jQuery(document).ready(function () {
      setTimeout(
        function () {
          jQuery('.navfullmenu').css('opacity', '1');
          jQuery('.newsfullmenu').css('opacity', '1');
          jQuery('.searchfullmenu').css('opacity', '1');
        }, 2000);
    });

    $(window).scroll(function () {
      var newsBtn = $('.side-buttons .side-button-newsletter');

      var searchBtn = $('.side-buttons .side-button-search');

      var container = $('.side-buttons'),
        containerPos = $('.side-buttons').position();

      var scrollTop = $(window).scrollTop();

      $('.home .color-switch').each(function (key, value) {
        var section = $(this),
          sectionPos = section.position();

        var trigger = scrollTop - sectionPos.top + containerPos.top + (container.outerHeight() / 2);

        if (trigger < section.outerHeight()) {
          if (trigger >= 0) {
            if (section.hasClass('section-light')) {
              searchBtn.removeClass('c_blanc');
              searchBtn.addClass('c_noir');

              newsBtn.removeClass('c_blanc');
              newsBtn.addClass('c_noir');
            } else {
              searchBtn.removeClass('c_noir');
              searchBtn.addClass('c_blanc');

              newsBtn.removeClass('c_noir');
              newsBtn.addClass('c_blanc');
            }
            return false;
          }
        }
      });
    });
  }
};
